import { EnumModel } from 'api/dto/Enum.dto';

export type BenchmarkSectorDto = { id: number; name: string };

export type ConstantDto = {
  benchmark_sectors: Array<BenchmarkSectorDto> | { [key: number]: string };
  pulse_frequencies: { [key: string]: string };
  employee_range_group: { [key: number]: string };
  demographics_constant: { [key: string]: string };
};

export type ConstantModel = {
  benchmarkSectors: EnumModel[];
  pulseFrequencies: EnumModel[];
  employeeRangeGroup: EnumModel[];
  demographics: EnumModel[];
};

function mapBenchmarkSectors(sectors: ConstantDto['benchmark_sectors']): EnumModel[] {
  if (Array.isArray(sectors)) {
    return sectors.map(({ id, name }) => ({ key: id, name }));
  }

  return Object.keys(sectors).map((id) => ({
    key: Number(id),
    name: sectors[Number(id)],
  }));
}

export function mapConstantDtoToModel(dto: ConstantDto): ConstantModel {
  return {
    benchmarkSectors: mapBenchmarkSectors(dto.benchmark_sectors),
    pulseFrequencies: Object.keys(dto.pulse_frequencies).map((key) => ({
      key,
      name: dto.pulse_frequencies[key],
    })),

    employeeRangeGroup: Object.keys(dto.employee_range_group).map((id) => ({
      key: Number(id),
      name: dto.employee_range_group[Number(id)],
    })),

    demographics: Object.keys(dto.demographics_constant).map((key) => ({
      key,
      name: dto.demographics_constant[key],
    })),
  };
}
